var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checklist__item",class:_vm.editClass},[_c('ChecklistsChecklistItemControl',{attrs:{"disabled":_vm.disabled,"item":_vm.item},on:{"status-changed":_vm.updateValues}}),_c('ChecklistsChecklistItemHeading',{attrs:{"item":_vm.item,"changes-saved":_vm.apiCallSucceed},on:{"save-changes":_vm.updateValues}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }